<template>
    <modal-base lead-state="initiated">
        <template #subtitle>Initiating call...</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
